export default __webpack_public_path__ + "static/media/1968.4ba0627e.jpg";